import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValueSet, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-edit-relationship',
  templateUrl: './edit-relationship.component.html',
  styleUrls: ['./edit-relationship.component.scss']
})
export class EditRelationshipComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["relationship"]; roles: KeyValueSet[]; id: string; enumId: string;
  constructor(private activeModal: NgbActiveModal, private languageManagementService: LanguageManagementService, public localService: LocalService, public profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.roles = this.roles.filter(x => x.key != '0' && x.key != '4');
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.profileManagementService.editRelationShip(this.id, this.enumId).subscribe(result => {
      if (result.status == Status.NotAllowed) {
        this.localService.showInformation(this.localService.languageContent.relationship['not_allowed'], true);
      } else {
        this.localService.showInformationByStatus(result.status);
      }
      if ([Status.Success, Status.NotAllowed].includes(result.status)) {
        this.activeModal.close({ event: result.status == Status.Success ? TriggeredEvent.Ok : TriggeredEvent.Close, enumId: this.enumId });
      }
    });
  }
}
